import { useState } from 'react';
import { faqData } from '@/mocks/home-data';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggle = (idx: number) => {
    setOpenIndex(openIndex === idx ? null : idx);
  };

  return (
    <section id="faq" className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading mb-2">常见问答</h2>
          <p className="text-sm text-foreground-600">关于吃瓜每日大赛，你想知道的都在这里</p>
        </div>

        <div className="max-w-3xl mx-auto flex flex-col gap-3">
          {faqData.map((item, idx) => (
            <div
              key={idx}
              className="rounded-lg bg-background-100 border border-background-200/70 overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between p-4 md:p-5 text-left cursor-pointer hover:bg-background-200/50 transition-colors"
                onClick={() => toggle(idx)}
              >
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 pr-4 leading-snug">
                  {item.q}
                </h3>
                <span className={`w-6 h-6 flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${openIndex === idx ? 'rotate-180' : ''}`}>
                  <i className="ri-arrow-down-s-line text-foreground-500 text-lg"></i>
                </span>
              </button>
              <div
                className={`transition-all duration-300 overflow-hidden ${
                  openIndex === idx ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <p className="px-4 md:px-5 pb-4 md:pb-5 text-sm text-foreground-600 leading-relaxed">
                  {item.a}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}